<app-rc-dialog-wrapper noClose="true">
  <div class="container-dialog">
    <div class="container-dialog__body">
      <!-- Image -->
      <div class="container-dialog__body-thumb">
        <img alt="" src="assets/other/alert_cat.png" />
      </div>

      <!-- Text -->
      <h3 class="rc-title-gamma" i18n="@@popin_active-program_title">Active programme</h3>
      <p class="rc-paragraph" i18n="@@popin_active-program_msg">
        It seams that this pet is already under a weight loss programme, starting a new programme will end the current one.
      </p>
    </div>

    <div class="container-dialog__footer">
      <rc-button data-qa="vs-pet-identification-active-programme-popin-button-stay" (click)="stay()">
        {{ 'popin_active-program_stay' | translateKey }}
      </rc-button>
      <span class="rc-button__separator" i18n="@@action_separator">or</span>
      <rc-link
        data-qa="vs-pet-identification-active-programme-popin-button-start-new"
        variant="secondary"
        size="large"
        (click)="startNewConsultation()"
      >
        {{ 'popin_active-program_start' | translateKey }}
      </rc-link>
    </div>
  </div>
</app-rc-dialog-wrapper>
